var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3611 0.726301C21.394 -0.2421 19.8179 -0.2421 18.8509 0.726301L18.3422 1.22654L22.8195 5.70299L23.2402 5.27971C23.73 4.7923 24 4.14457 24 3.44552C24 2.74648 23.73 2.09874 23.2465 1.61133L22.3611 0.726301Z",
    fill: "#7D90B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0942 3.46475L20.5714 7.94118L21.9215 6.60082L17.4443 2.12439L16.0942 3.46475Z",
    fill: "#7D90B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12245 17.3879L0 24L6.61224 21.8451L19.6735 8.83906L15.1962 4.36261L2.12245 17.3879Z",
    fill: "#7D90B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.5b3b90466602c5cd1f4f418bb5f7d2ce.svg";
export { ForwardRef as ReactComponent };